import React, { Fragment, useEffect, useState } from 'react';
import './scss/style.scss';
// import { MantineProvider } from '@mantine/core';
// import '@mantine/core/styles.css';
// import '@mantine/dates/styles.css';
import { Container } from '@mui/material';
import WebsiteFooter from './footer';
import ToTop from './footer/ToTop';

import {
  getWebsiteLanguage,
  setActiveResource,
  setAlertTranslations,
  setContentTranslations,
  setControlsTranslations,
  setGeneralTranslations,
  setValidationTranslations,
  setResources,
  setInstutucionet
} from './store/dataslice';
import { useDispatch, useSelector } from 'react-redux';
import reducer from './store';
import { injectReducer } from 'store/index';
import { getData } from './services/fetch-service';
import Home from './components/Home';
import Navmenu from './header/Navmenu';
import Sinjalizimi from './components/Steppers/Sinjalizimi';
import KonfliktInteresit from './components/Steppers/KonfliktInteresit';
import Deklarimi from './components/Steppers/Deklarimi';
import Search from './components/Search';
import Tjeter from './components/Steppers/Tjeter';
import MobileHeader from './mobile/MobileHeader';
import MobilePanel from './mobile/mobilePanel';
import { Route, Routes } from 'react-router-dom';

injectReducer('WebsiteLanguage', reducer)

const Website = (props) => {
  const { headerLayout, homeComponent } = props;

  const dispatch = useDispatch();
  const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
  const Resources = useSelector((state) => state.WebsiteLanguage.data.Resources);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [homeComponent]);

  useEffect(() => {
    dispatch(getWebsiteLanguage())
    getData('Home/GetResourceTranslationsByTypeAndLanguage').then((response) => {
      dispatch(setResources({ data: response.data }))
    });
    getData('Home/GetInstitutions').then((response) => {
      dispatch(setInstutucionet(response.data))
    });
  }, []);

  useEffect(() => {
    if (Resources && Resources.data) {
      dispatch(setActiveResource(Resources.data[0].resourceTranslationType));
      if (WebsiteLanguage === 'sq') {
        dispatch(setActiveResource(Resources.data[0].resourceTranslationType));
      } else if (WebsiteLanguage === 'en') {
        dispatch(setActiveResource(Resources.data[1].resourceTranslationType));
      } else if (WebsiteLanguage === 'sr') {
        dispatch(setActiveResource(Resources.data[2].resourceTranslationType));
      } else {
        dispatch(setActiveResource(Resources.data));
      }
    }
  }, [WebsiteLanguage, Resources]);

  const ActiveResource = useSelector((state) => state.WebsiteLanguage.data.ActiveResource);

  // General
  const GeneralTranslationsObject = ActiveResource.find((resource) => resource.name === 'General');
  let GeneralResourceTranslationString;
  if (GeneralTranslationsObject) {
    GeneralResourceTranslationString = GeneralTranslationsObject.resourceTranslationString;
  }

  let General = {};
  if (Array.isArray(GeneralResourceTranslationString)) {
    for (const obj of GeneralResourceTranslationString) {
      if (obj.name && obj.value) {
        General[obj.name] = obj.value;
      }
    }
  }

  useEffect(() => {
    dispatch(setGeneralTranslations(General));
  }, [General]);

  //Validation
  const ValidationTranslationsObject = ActiveResource.find((resource) => resource.name === 'Validation');
  let ValidationResourceTranslationString;
  if (ValidationTranslationsObject) {
    ValidationResourceTranslationString = ValidationTranslationsObject.resourceTranslationString;
  }

  let Validation = {};
  if (Array.isArray(ValidationResourceTranslationString)) {
    for (const obj of ValidationResourceTranslationString) {
      if (obj.name && obj.value) {
        Validation[obj.name] = obj.value;
      }
    }
  }

  useEffect(() => {
    dispatch(setValidationTranslations(Validation));
  }, [Validation]);

  // Alerts
  const AlertTranslationsObject = ActiveResource.find((resource) => resource.name === 'Alert');
  let AlertResourceTranslationString;
  if (AlertTranslationsObject) {
    AlertResourceTranslationString = AlertTranslationsObject.resourceTranslationString;
  }

  let Alerts = {};
  if (Array.isArray(AlertResourceTranslationString)) {
    for (const obj of AlertResourceTranslationString) {
      if (obj.name && obj.value) {
        Alerts[obj.name] = obj.value;
      }
    }
  }

  useEffect(() => {
    dispatch(setAlertTranslations(Alerts));
  }, [Alerts]);

  // Controls
  const ControlsTranslationsObject = ActiveResource.find((resource) => resource.name === 'Controls');
  let ControlsResourceTranslationString;
  if (ControlsTranslationsObject) {
    ControlsResourceTranslationString = ControlsTranslationsObject.resourceTranslationString;
  }

  let Controls = {};
  if (Array.isArray(ControlsResourceTranslationString)) {
    for (const obj of ControlsResourceTranslationString) {
      if (obj.name && obj.value) {
        Controls[obj.name] = obj.value;
      }
    }
  }

  useEffect(() => {
    dispatch(setControlsTranslations(Controls));
  }, [Controls]);

  // Content
  const ContentTranslationsObject = ActiveResource.find((resource) => resource.name === 'Content');
  let ContentResourceTranslationString;
  if (ContentTranslationsObject) {
    ContentResourceTranslationString = ContentTranslationsObject.resourceTranslationString;
  }

  let Content = {};
  if (Array.isArray(ContentResourceTranslationString)) {
    for (const obj of ContentResourceTranslationString) {
      if (obj.name && obj.value) {
        Content[obj.name] = obj.value;
      }
    }
  }

  useEffect(() => {
    dispatch(setContentTranslations(Content));
  }, [Content]);

  return (
    // <MantineProvider>

    <Fragment>
      <MobilePanel locale={WebsiteLanguage} layout={headerLayout} />
      <div className="site">

        <header className="site__header mobile-nav">
          <MobileHeader locale={WebsiteLanguage} />
        </header>

        <header className="apk-header  dekstop-nav">
          <Navmenu />
        </header>

        <div className="apk-body">
          <Container maxWidth="xl">
            <Routes>
              <Route exact path="/" element={<Home locale={WebsiteLanguage} />} />
              <Route exact path="/Sinjalizim" element={<Sinjalizimi locale={WebsiteLanguage} />} />
              <Route exact path="/KonfliktIntersit" element={<KonfliktInteresit locale={WebsiteLanguage} />} />
              <Route exact path="/DeklarimiPasuriseDheDhuratave" element={<Deklarimi locale={WebsiteLanguage} />} />
              <Route exact path="/Tjeter" element={<Tjeter locale={WebsiteLanguage} />} />
              <Route exact path="/Kerko" element={<Search locale={WebsiteLanguage} />} />
              <Route path="/Kerko/:id" element={<Search locale={WebsiteLanguage} />} />
            </Routes>
          </Container>
        </div>

        <footer className="site__footer">
          <WebsiteFooter location={homeComponent} />
          <ToTop />
        </footer>

      </div>
    </Fragment>
    // </MantineProvider>
  );
};

export default Website;
